import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface PlaceholderState {
	definitions: { [key: string]: string };
	submitMappings: { [key: string]: string };
}

const initialState: PlaceholderState = {
	definitions: {},
	submitMappings: {},
};

export const placeholderSlice = createSlice({
	name: 'PlaceholderSlice',
	initialState,
	reducers: {
		setPlaceholderDefinitions: (state, action: PayloadAction<MetaArea>) => {
			const metaArea = action.payload;
			const definitions = {};
			const submitMappings = {};
			metaArea.items?.forEach((metaAreaContent) => {
				const defs = metaAreaContent.content?.placeholderDefinitions?.globalDefinitions;
				if (defs) {
					// use keys toUpper
					Object.keys(defs).forEach((key) => {
						definitions[key.toUpperCase()] = defs[key];
						submitMappings[defs[key]] = key;
					});
				}
			});

			return {
				...state,
				definitions,
				submitMappings,
			};
		},
	},
});

export const { setPlaceholderDefinitions } = placeholderSlice.actions;
export default placeholderSlice.reducer;
